<template>
  <div>
    <!-- 富文本编辑器 -->
    <Editor
      :id="tinymceId"
      v-model="articleContent"
      :init="editorInit"
      :key="tinymceFlag"
    ></Editor>
  </div>
</template>
<script>
import axios from "axios";
// 引入Tinymce编辑器
import tinymce from "tinymce/tinymce";
import Editor from "@tinymce/tinymce-vue";
//引入工具栏图标和主题
import "tinymce/icons/default/icons";
import "tinymce/themes/silver";
// 引入富文本编辑器主题的js和css，不然显示出错
import "tinymce/themes/silver/theme.min";
import "tinymce/skins/ui/oxide/skin.min.css";
// 扩展插件 - 根据需要引入
import "tinymce/plugins/image";
import "tinymce/plugins/link";
import "tinymce/plugins/code";
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import "tinymce/plugins/wordcount"; // 字数统计插件
import "tinymce/plugins/media"; // 插入视频插件
import "tinymce/plugins/template"; // 模板插件
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/paste";
import "tinymce/plugins/preview";
import "tinymce/plugins/searchreplace";
import "tinymce/plugins/charmap";
import "tinymce/plugins/emoticons";
import "tinymce/plugins/emoticons/js/emojis";
import "tinymce/plugins/help";
import "tinymce/plugins/codesample";
import "tinymce/plugins/contextmenu";
import "tinymce/plugins/colorpicker";
import "tinymce/plugins/textcolor";
import "tinymce/plugins/advlist";
import "tinymce/plugins/hr";
import "tinymce/plugins/textpattern";
import "tinymce/plugins/autolink";
import "tinymce/plugins/directionality";
import "tinymce/plugins/visualblocks";
import "tinymce/plugins/visualchars";
import "tinymce/plugins/nonbreaking";
import "tinymce/plugins/insertdatetime";
import "tinymce/plugins/imagetools";
import "tinymce/plugins/autosave";
import "tinymce/plugins/autoresize";
import "@/assets/js/plugins/axupimgs/plugin";
// import 'axupimgs'
export default {
  name: "TinymceEditor",
  components: { Editor },
  props: {
    height: {
      type: [String, Number],
      default: 1000,
    },
    //从后台获取的字符串HTML数据，
    value: {
      type: String, // 这里我设定个默认值，实际开发中可至为空 - default:"",根据需求修改。
      default: "",
    }, // 基本路径，默认为空根目录
    baseUrl: {
      type: String,
      default: "",
    },
    // 图片附件上传地址
    uploadImgServer: {
      default: "/common/uploadFileUrl",
      type: String,
    },
    // 视频附件上传地址
    uploadVideoServer: {
      default: "/common/uploadFileUrl",
      type: String,
    },
    plugins: {
      //使用的插件 - 根据需求进行删减
      type: [String, Array],
      default:
        "visualblocks link lists image code table fullscreen template paste preview searchreplace colorpicker  wordcount\
           charmap emoticons help codesample media contextmenu textcolor advlist hr textpattern autolink\
            directionality  visualchars nonbreaking insertdatetime imagetools autosave axupimgs",
    },
    toolbar: {
      //工具栏 - 根据需求进行删减
      type: [String, Array],
      default:
        "fontselect fontsizeselect styleselect undo redo restoredraft cut copy paste pastetext forecolor \
         backcolor bold italic underline strikethrough link codesample code alignleft aligncenter alignright alignjustify outdent indent lineheight formatpainter \
         bullist numlist blockquote subscript superscript removeformat table image media charmap hr pagebreak insertdatetime fullscreen preview axupimgs",
    },
  },
  data() {
    var random = Math.round(Math.random() * 5000);
    return {
      tinymceId: "tinymce" + random,
      articleContent: this.value,
      tinymceFlag: "",
      index: 0,
      editorInit: {
        language_url: "tinymce/langs/zh_CN.js", //引用static下的文件,确保打包后也能引用成功
        language: "zh_CN",
        skin_url: "tinymce/skins/ui/oxide", // skin路径，到样式文件夹即可
        content_css: "/tinymce/skins/content/default/content.css", //样式规则
        height: 800,
        image_dimensions: false,
        relative_urls: false,
        remove_script_host: false,
        convert_urls: true,
        font_formats:
          "微软雅黑='微软雅黑';宋体='宋体';黑体='黑体';仿宋='仿宋';楷体='楷体';隶书='隶书';幼圆='幼圆';Andale Mono=andale mono,times;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Symbol=symbol;Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;Times New Roman=times new roman,times;Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva;Webdings=webdings;Wingdings=wingdings",
        plugins: this.plugins,
        toolbar: this.toolbar,
        content_style:
          "* { padding:0; margin:0; } img {max-width:100% !important; vertical-align: bottom; }",
        plugin_preview_width: 375, // 预览宽度
        plugin_preview_height: 668, //预览高度
        paste_data_images: true,
        powerpaste_word_import: "merge",
        images_reuse_filename: true,
        branding: false,
        image_resize: true,
        image_resize_max_width: '100%',
        statusbar: true, // 底部的状态栏
        menubar: true, // 最上方的菜单
        images_upload_handler: (blobInfo, success, failure) => {
          var fileData = new FormData();
          fileData.append("file", blobInfo.blob());
          fileData.append("type", 0);
          fileData.append("fileType", 0);

          axios
            .post("https://xcx.maxchemicals.com/common/uploadFileUrl", fileData)
            .then((res) => {
              success(res.data.msg);
            });
        },
        file_picker_callback: function (callback, value, meta) {
          if (meta.filetype === "media") {
            // 模拟上传本地视频
            let input = document.createElement("input");
            input.setAttribute("type", "file");
            input.setAttribute("accept", ".mp4");
            input.onchange = function () {
              let file = this.files[0];
              let fd = new FormData();
              fd.append("file", file);
              fd.append("type", 0);
              fd.append("fileType", 1);
              axios
                .post("https://xcx.maxchemicals.com/common/uploadFileUrl", fd)
                .then((res) => {
                  success(res.data.msg);
                });
            };
            input.click();
          }
        },
        setup: (editor) => {
          editor.on("blur", () => {
            this.Blur();
          });
        },
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    Blur() {
      this.$emit("blur");
    },

    init() {
      const that = this;
      tinymce.init({
        selector: `#${that.tinymceId}`,
        height: 2000,
        resize: false,
      });
    },
  },
  model: {
    prop: "value",
    event: "change",
  },
  watch: {
    value(newValue) {
      this.articleContent = newValue;
    },

    articleContent(newValue) {
      console.log("改变改变");
      this.$emit("change", newValue);
    },
  },
};
</script>
<style></style>
